import { useEffect, useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
});

const useController = ({ onSelect, initialValue, totalCounts, options }) => {
	const { translate } = useSelector(selectTranslate);

	const [value, setValue] = useState(initialValue);

	const handleChange = (e) => {
		setValue(e.target.value);
		onSelect?.(e.target.value);
	};

	useEffect(() => {
		if (totalCounts && (!(totalCounts["casino"] > 0) || !(totalCounts["live_casino"] > 0))) {
			const defaultOption = options.find((option) => totalCounts?.[option.key] > 0);
			if (defaultOption) {
				setValue(defaultOption.value);
			}
		}
	}, [totalCounts]);

	useEffect(() => {
		if (initialValue) {
			setValue(initialValue);
		}
	}, [initialValue]);

	return {
		helpers: { translate },
		state: { value },
		handlers: { handleChange },
	};
};

export default useController;
